<template>
  <div class="grid-x grid-margin-x pega-mt-05">
    <div
      class="margin-left-1"
      data-test="label"
    >
      <span>{{ label }}</span>
    </div>
    <div class="margin-left-3">
      <label
        v-for="(option ,i) in options"
        :key="i"
        class="pega-badge-radio pega-mr-5"
      >
        <input
          :data-test="`radio-value-${i}`"
          :value="option.id"
          :checked="value === option.id"
          type="radio"
          @change="$emit('input', $event.target._value)"
        >
        <span
          :data-test="`radio-label-${i}`"
          class="pega-badge-radio-text pega-badge-radio-check-mark"
        >{{ option.name }}</span>
      </label>
      <slot name="error" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
